import React from 'react';
import { TextField } from '@material-ui/core';
import { usePageContext } from '../../context/PageContext';

export function InputField({
  value,
  label,
  readOnly,
  inputProps,
  InputLabelProps,
  ...props
}) {
  const { customFieldName } = usePageContext();

  return (
    <TextField
      value={value || ''} // to avoid error "component is changing an uncontrolled input"
      label={customFieldName(label)}
      inputProps={{
        readOnly: readOnly,
        ...inputProps,
      }}
      fullWidth
      InputLabelProps={{
        shrink: true,
        ...InputLabelProps,
      }}
      {...props}
    />
  );
}

export default InputField;
